<template>
    <div class="panel" :class="shadow?'panel__shadow ':''+border?'panel__border':''">
        <slot></slot>
    </div>
</template>
<script>
export default{
    props:{
        shadow:{type:Boolean,default:true},
        border:{type:Boolean,default:false}
    }
}
</script>
<style>
    .panel.panel__border{
        border:solid 1px #EDF6FF
        
    }
    .panel.panel__shadow{
        box-shadow:0 0 40px 0 #EEEEEE66, 0 5px 5px 0 #E5EDF5;
    }
    .panel.panel__shadow-hover:hover{
        box-shadow: 0px 0px 40px 0px #EEEEEE66, 0px 8px 10px 0px #D8DFE5;
    }
    .panel{
        display: inline-block;
        box-sizing: border-box;
        border-radius: 10px;
        background-color: var(--white);
        overflow: hidden;
        z-index: 2;
    }
    .panel h3{
        margin: 0;
        font-size: 14px;
        font-weight: 500;
        line-height: 130%;
        color: #0D3041;
    }
    .panel p{
        margin: 0;
        margin-top: 5px;
        font-size: 14px;
        color: #0D3041;
        line-height: 130%;
    }
    .panel a{
        margin: 0;
        margin-top: 5px;
        font-size: 14px;
        color: #174E72;
        text-decoration: none;
        line-height: 130%;
    }
    .panel a:hover{
        color: #007BB8;
    }
    .panel li{
        margin-left: 20px ;
        font-size: 14px;
        color: #0D3041;
    }
    .panel img{
        display: block;
        object-position: top;
        object-fit: cover;
    }
    .panel.panel__button{
        width: 100%;
    }
    .panel.panel__button:hover{
        box-shadow: 0px 0px 40px 0px #EEEEEE66, 0px 8px 10px 0px #D8DFE5;
    }
    .panel.panel__button:hover a[href^="https"],
    .panel.panel__button:hover a[href^="http"]{
         color: #007BB8;
    }
    .panel.panel__button:hover details a[href^="https"],
    .panel.panel__button:hover details a[href^="http"]{
         color: #174E72;
    }
    .panel.panel__button:hover details a:hover{
         color: #007BB8;
    }
    .panel.panel__button>*{
        padding: 34px 32px;
        width: 100%;
    }
    .panel.panel__button a{
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        
        align-items: center;
        font-weight: 500;
        box-sizing: border-box;
    }
    .panel.panel__button a[href^="http"],
    .panel.panel__button a[href^="https"]{
        text-decoration: underline;
    }
    .html__panel .panel{
        padding: 32px;
        color:#0D3041;
        font-size: 14px;
    }
    .html__panel .panel a{
        text-decoration:underline;
        font-weight: 500;
    }
    .html__panel .panel h3{
        font-size: 16px;
        margin-bottom: 32px;
    }
    .html__panel .panel h2,
    .html__panel .panel h3,
    .html__panel .panel h4,
    .html__panel .panel h5,
    .html__panel .panel h5{
        font-weight: 400;
    }
   .data__panel .information{
        margin-top: 16px;
    }
    .data__panel .information h4{
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 130%;
        color: #919191;
    }
    details{
        box-sizing: border-box;
    }
    details summary{
        position: relative;
        display: block;
        transition: .3s;
        overflow: hidden;
        box-sizing: border-box;
    }
    details summary::after {
        position: absolute;
        right: 0;
        top: 0;
        content: url(../../assets/corner.svg);;
        transform: rotate(180deg);
        transform-origin: center;
        transition: .3s;
    }
    details[open] summary::after {
        transform: rotate(0deg);
    }
    details[open] summary {
        margin-bottom: 34px;
    }
    details summary {
        cursor: pointer;
        transition: .3s;
    }
    details summary h3{
        margin-right: 20px;
    }
    @media (max-width: 1000px){
        .html__panel .panel{
            padding: 16px
        }
        .panel.panel__button>*{
            padding: 16px;
        }
        
        .panel.panel__button a{
            font-size: 14px;
            margin: 0;
        }
    }


</style>
